export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7424.e1b83a7a.jpg";